var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 6.90308L87.323 28.4515V71.5484L50 93.0968L12.677 71.5484V28.4515L50 6.90308ZM16.8647 30.8693V62.5251L44.2795 15.0414L16.8647 30.8693ZM50 13.5086L18.3975 68.2457H81.6025L50 13.5086ZM77.4148 72.4334H22.5852L50 88.2613L77.4148 72.4334ZM83.1353 62.5251L55.7205 15.0414L83.1353 30.8693V62.5251Z",
    fill: "#E10098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 18.1409C54.8712 18.1409 58.8201 14.192 58.8201 9.32085C58.8201 4.4497 54.8712 0.500854 50.0001 0.500854C45.1289 0.500854 41.1801 4.4497 41.1801 9.32085C41.1801 14.192 45.1289 18.1409 50.0001 18.1409Z",
    fill: "#E10098"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2292 38.4805C90.1003 38.4805 94.0492 34.5316 94.0492 29.6605C94.0492 24.7893 90.1003 20.8405 85.2292 20.8405C80.358 20.8405 76.4092 24.7893 76.4092 29.6605C76.4092 34.5316 80.358 38.4805 85.2292 38.4805Z",
    fill: "#E10098"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2292 79.1597C90.1003 79.1597 94.0492 75.2108 94.0492 70.3397C94.0492 65.4685 90.1003 61.5197 85.2292 61.5197C80.358 61.5197 76.4092 65.4685 76.4092 70.3397C76.4092 75.2108 80.358 79.1597 85.2292 79.1597Z",
    fill: "#E10098"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 99.4991C54.8712 99.4991 58.8201 95.5503 58.8201 90.6791C58.8201 85.808 54.8712 81.8591 50.0001 81.8591C45.1289 81.8591 41.1801 85.808 41.1801 90.6791C41.1801 95.5503 45.1289 99.4991 50.0001 99.4991Z",
    fill: "#E10098"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7659 79.1597C19.6371 79.1597 23.5859 75.2108 23.5859 70.3397C23.5859 65.4685 19.6371 61.5197 14.7659 61.5197C9.89477 61.5197 5.94592 65.4685 5.94592 70.3397C5.94592 75.2108 9.89477 79.1597 14.7659 79.1597Z",
    fill: "#E10098"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7659 38.4805C19.6371 38.4805 23.5859 34.5316 23.5859 29.6605C23.5859 24.7893 19.6371 20.8405 14.7659 20.8405C9.89477 20.8405 5.94592 24.7893 5.94592 29.6605C5.94592 34.5316 9.89477 38.4805 14.7659 38.4805Z",
    fill: "#E10098"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.d6958973566d3deef9321853a6570259.svg";
export { ForwardRef as ReactComponent };